import { render, staticRenderFns } from "./usuarioRecursosExternos.vue?vue&type=template&id=20a57cc4"
import script from "./usuarioRecursosExternos.vue?vue&type=script&lang=js"
export * from "./usuarioRecursosExternos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports